export default "__VITE_ASSET__3Pt3_s94__"